import React from 'react'
import Link from 'gatsby-link'

import Divider from '../images/Divider.svg'

const Contact = () => (
  <section>
    <article className="container">
      <div style={{display:'block'}}>
        <h1 className='smallerHone'>Contact</h1>
        <img src={Divider} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
        <p className='smallerHone'><span className='gradient'>Leave us a quick message or feel free to visit us anytime!</span></p>
        <p style={{marginBottom:'0'}}>See how businesses similar to yours are growing with Digital Marketing.</p>
      </div>
    </article>
  </section>
)

export default Contact



// WEBPACK FOOTER //
// ./src/pages/contact.js